import i from "./ghl-ui.es1466.js";
import t from "./ghl-ui.es1467.js";
function d(r, a, e) {
  i(2, arguments);
  var f = t(r, e), m = t(a, e);
  return f.getTime() === m.getTime();
}
export {
  d as default
};
